import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import React from 'react';
import styled from 'styled-components/macro';
import PublicPage from 'components/PublicPages/PublicPage';
import { variables } from 'theme/variables';
const {
  media_sm,
  public_app_max_width,
  media_lg
} = variables;



export const StyledLandingSection = styled('div')`
  background-color: ${(props) => props.background || '#fff'};
`;

export const InlineSection = styled('div')`
  margin-bottom: 0;
  @media ${media_sm} {
    margin-bottom: 60px;
  }
`;

export const LandingPage = styled(PublicPage)`
  padding-top: 0px;
`;


export const ServicesPage = styled(PublicPage)`
  padding-top: 0px;
`;


export const LandingSectionInner = styled('div')`
  max-width: ${public_app_max_width};
  margin: 0 auto;
  padding: ${(props) => '50px' || '0'} 15px 50px;
  @media ${media_sm} {
    padding: ${(props) => '50px' || '0'} 40px 50px;
  }
  @media (min-width: 1430px) {
    padding: ${(props) => '50px' || '0'} 20px 50px;
  }
`;


export const LandingSection = (props) => {
  return (
    <StyledLandingSection background={props.background}>
      <LandingSectionInner background={props.background} style={props.style || {}}>
        <Grid>
          <Row>
            <Col style={props.colStyle || {}}>
              {props.children}
            </Col>
          </Row>
        </Grid>
      </LandingSectionInner>
    </StyledLandingSection>
  )
}
